import {
  keepPreviousData,
  MutationCache,
  QueryCache,
  QueryClient,
  type DefaultOptions,
} from '@tanstack/react-query';
import { ApiError } from './client';
import { getErrorMessage } from './errors';

const mapApiError = (err: unknown): ApiError =>
  err instanceof ApiError ? err : new ApiError(getErrorMessage(err));

const defaultOptions: DefaultOptions = {
  queries: {
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    retry: (failureCount, error) => {
      const mapped = mapApiError(error);
      const status = mapped.status ?? 0;
      if (status >= 400 && status < 500) {
        return false;
      }
      return failureCount < 2;
    },
  },
  mutations: { retry: 0 },
};

export const createAppQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions,
    queryCache: new QueryCache({
      onError: (error) => {
        mapApiError(error);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        mapApiError(error);
      },
    }),
  });

export type AppQueryClient = QueryClient;
